module.exports = __webpack_public_path__ + "static/img/right-home-row-3.6191533d.png";